<template>
  <div class="loading" :style="{ background: bgColor }">
    <div class="loading-container">
      <div
        class="el-icon-loading icon-reset"
        :style="{ color: iconColor }"
      ></div>
      <div class="icon-text" :style="{ color: iconColor }">{{ text }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "loading",
  props: {
    // 字体颜色
    textColor: {
      type: String,
      default: "#ff6c00"
    },
    // 图标颜色
    iconColor: {
      type: String,
      default: "#ff6c00"
    },
    // 字
    text: {
      type: String,
      default: "加载中..."
    },
    // 背景
    bgColor: {
      default: "rgba(0, 0 ,0, 0.3)"
    }
  }
};
</script>
